import { createContext } from 'react';

type LabelContextValue = { id: string };

export const LabelContext = createContext<LabelContextValue | undefined>(undefined);
